import { getAxiosClient } from '@givelify/utils';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { makeApiRequest } from '../../api/utils/makeApiRequest';
import {
    SetupCCBFormData,
    SetupF1GoFormData,
} from '../../pages/integrations/IntegrationContent/TabsContent/AutoIntegrationContent/types';
import { webConfig } from '../../webConfig';
import { AppActions, AppState } from '../index';
import { httpPost } from '../thunks';
import { setIntegration } from './action';
import { AutoIntegration } from './types';

export const getIntegration = (
    doneeId: number,
): ThunkAction<Promise<boolean>, AppState, undefined, AppActions> => {
    return async (dispatch) => {
        const httpRequest = getAxiosClient().get(
            `/donees/${doneeId}/integration/details`,
        );
        const response = await makeApiRequest<AutoIntegration>(httpRequest);

        dispatch(setIntegration(response.response ?? null));
        return true;
    };
};

export const newCCBIntegration = (
    data: SetupCCBFormData,
    doneeId: number,
): ThunkDispatch<AppState, undefined, AppActions> => {
    return async (dispatch) => {
        const { data: resData } = await httpPost(
            `${webConfig.baseUrl}/donees/${doneeId}/integration/registration`,
            {
                type: 'CCB',
                credentials: data,
            },
        )(dispatch);
        dispatch(setIntegration(resData));
    };
};

export const newF1GoIntegration = (
    data: SetupF1GoFormData,
    doneeId: number,
): ThunkDispatch<AppState, undefined, AppActions> => {
    return async (dispatch) => {
        const { data: resData } = await httpPost(
            `${webConfig.baseUrl}/donees/${doneeId}/integrations`,
            {
                type: 'F1GO',
                credentials: data,
            },
        )(dispatch);
        dispatch(setIntegration(resData));
    };
};
